import React from 'react';

import { useJobDescriptionsFromExternalWebsitesState, useJobDescriptionsFromExternalWebsitesActions } from './JobDescriptionsFromExternalWebsitesContext';
import { reopenJobDescriptionFromExternalWebsite } from './restApi';

import Form from '../../Shared/UI/Form/components/Form';
import FormInstruction from '../../Shared/UI/FormInstruction/components/FormInstruction';
import FormActions from '../../Shared/UI/FormActions/components/FormActions';
import Button from '../../Shared/UI/Button/components/Button';
import ResponsiveContainer from '../../Shared/UI/ResponsiveContainer/components/ResponsiveContainer';

const ReopenJobDescriptionFromExternalWebsiteForm = () => {
  const jobDescriptionsFromExternalWebsitesState = useJobDescriptionsFromExternalWebsitesState();
  const { onResponse, onError, closeReopenJobDescriptionFromExternalWebsiteModal } = useJobDescriptionsFromExternalWebsitesActions();
  const authenticityToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");

  const handleSubmit = () => {
    reopenJobDescriptionFromExternalWebsite({
      onResponse,
      onError,
      body: {
        authenticityToken,
        reopenJobDescriptionFromExternalWebsite: jobDescriptionsFromExternalWebsitesState?.reopenJobDescriptionFromExternalWebsite,
      },
    });
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormInstruction>
        Are you sure you want to reopen this job description from external website?
      </FormInstruction>

      <ResponsiveContainer name="form-actions">
        <FormActions>
          <Button
            variant="secondary"
            onClick={() => closeReopenJobDescriptionFromExternalWebsiteModal()}
          >
            Cancel
          </Button>
          <Button type="submit">
            Yes. Reopen This Job Description from External Website.
          </Button>
        </FormActions>
      </ResponsiveContainer>
    </Form>
  );
};

export default ReopenJobDescriptionFromExternalWebsiteForm;
